import {AfterViewInit, ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import {DayService, EventSettingsModel, MonthService, PopupCloseEventArgs, PopupOpenEventArgs, ScheduleComponent, WeekService, WorkWeekService} from '@syncfusion/ej2-angular-schedule';
import {L10n, loadCldr, setCulture} from '@syncfusion/ej2-base';
import {LocalStorageService} from 'src/app/local-storage.service';
import {ServiceAppModels} from 'src/app/models/serviceapp-models';
import {ServiceAppComponent} from '../service-app.component';
import {ServiceAppService} from 'src/app/services/service-app.service';
import {SwissSettingsService} from 'src/app/services/swiss-settings.service';
import {MessageBoxService} from 'src/app/services/message-box.service';
import {MatDialog} from '@angular/material/dialog';
import {EinsatzEintragComponent} from './einsatz-eintrag/einsatz-eintrag.component';
import {v4 as uuidv4} from 'uuid';
import {DatumFormatPipe} from 'src/app/pipes/datum-format.pipe';
import {TimeRecorderComponent} from './time-recorder/time-recorder.component';
import {ObjektDataService} from 'src/app/services/objekt-data.service';
import {ObjektModels} from 'src/app/models/objekt-models';
import {UserAuthenticationService} from 'src/app/services/user-authentication.service';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {tap} from 'rxjs';

@Component({
    selector: 'app-agenda',
    templateUrl: './agenda.component.html',
    styleUrls: ['./agenda.component.scss'],
    providers: [MonthService, DayService, WeekService, WorkWeekService],
    encapsulation: ViewEncapsulation.None,
    host: {
        class: 'host'
    }
})
export class AgendaComponent implements OnInit, AfterViewInit, OnDestroy {

    public dateFormat: string = 'dd.MM.yyyy';
    public timeFormat: string = 'HH:mm';
    public choosedView: string = 'WorkWeek';

    public eventSettings: EventSettingsModel = {
        allowDeleting: false,
        dataSource: undefined,
        fields: {
            location: {name: 'Standort', title: 'Auftrag Standort'},
        },
    };
    public showRecordState: ServiceAppModels.RecordingState =
        ServiceAppModels.RecordingState.NoRecording;
    public flag = false;
    public currTimeRecordTermin?: ServiceAppModels.SA_Objekt; // Bezieht sich auf ausgewählten Auftrag
    public currTimeRecordObjekt?: ObjektModels.ObjektElement; // Bezieht sich auf ausgewählter Objekt
    public startZeitRecording?: string;
    public auftragsZeitTotal?: string;
    public tagesTotal?: string;
    // Setzt das Datum auf den jetztigen Zeitpunkt
    public selectedDate: Date = new Date();
    public dayStartTime: string = '07:00';
    public dayEndTime: string = '20:00';
    public showWeekend: boolean = false;
    public showQuickInfo: boolean = false;
    @ViewChild('scheduleObj') public scheduleObj?: ScheduleComponent;
    private dbStorageSA: string = 'ServiceAppDB';
    private dbAuftragsKategorien?: ServiceAppModels.SA_ObjektKategorie[];
    private dbTermine?: ServiceAppModels.SA_Objekt[];
    private currTermin?: ServiceAppModels.SA_Objekt;
    private myDataSource: object[] = [];
    private isAndroid: boolean = false;
    // Zeit-Recording
    private timeRecordingItem?: ServiceAppModels.TimeRecordingItem;
    private rasterStartTime: string = '05:00';
    private rasterEndTime: string = '22:00';
    // Angeklickte Elemente speichern
    private lastClickedAppointment: any;
    private lastClickedAppointmentEvent: any;
    private currClickedAppointment: any;
    private currClickedAppointmentEvent: any;
    private lastChoosedRowID: string = '';

    // Termin-Verschiebung
    private terminBefore?: ServiceAppModels.Appointment;
    private terminAfter?: ServiceAppModels.Appointment;

    // Einsatz-Erfassung
    private dataForAssignment?: ServiceAppModels.Assignment;
    private refreshObjectRecordingInterval;

    constructor(
        private localStorageService: LocalStorageService,
        private saComp: ServiceAppComponent,
        private swissSettings: SwissSettingsService,
        private svcSA: ServiceAppService,
        private svcObjekte: ObjektDataService,
        public dialog: MatDialog,
        private userAuthService: UserAuthenticationService,
        private svcMessageBox: MessageBoxService,
        private _datumFormatPipe: DatumFormatPipe,
        private changeDetection: ChangeDetectorRef
    ) {
        this.svcSA
            .getChoosedAppointmentFromDB()
            .then((value) => (this.lastChoosedRowID = value));

        this.svcSA.getTimesChanged$().pipe(
            takeUntilDestroyed(),
            tap(() => this.noTerminSelected())
        ).subscribe();
    }

    ngOnDestroy(): void {
        clearInterval(this.refreshObjectRecordingInterval);
    }

    ngAfterViewInit(): void {
        this.loadOrders();
        // TimeRecording aus Indexed-DB laden, wenn vorhanden
        this.svcSA.getTimeRecordingItems().then((value) => {
            if (value && value.length > 0) {
                this.timeRecordingItem = value[value.length - 1];
                if (this.timeRecordingItem) {
                    this.showRecordState = this.timeRecordingItem.recordingState;
                    this.showObjektRecordingData();
                }
            }
        });

        if (/Mobi|Android/i.test(navigator.userAgent)) {
            // mobile!
            this.isAndroid = true;
        }

        this.scheduleObj!.eventSettings.dataSource = this.myDataSource;
        if (this.scheduleObj) {
            // Steuert die weisse Fläche für die Termine
            this.scheduleObj.workHours.start = this.dayStartTime;
            this.scheduleObj.workHours.end = this.dayEndTime;

            // Steuert die graue Fläche für Termine
            this.scheduleObj.views.forEach((view: any) => {
                view.startHour = this.rasterStartTime;
                view.endHour = this.rasterEndTime;
                view.isSelected = view.option === this.choosedView;
            });
        }
        this.refreshObjektRecordingData();
    }

    ngOnInit(): void {
        // Lädt die zuletzt gewählte Ansicht

        this.choosedView = this.svcSA.getLastChosenView();

        this.dayStartTime = this.swissSettings.getTimeGridStart();
        this.dayEndTime = this.swissSettings.getTimeGridEnd();
        this.rasterStartTime = this.swissSettings.getTimeGridStart();
        this.rasterEndTime = this.swissSettings.getTimeGridEnd();
        // Hier wird dem Service-App-Service mitgeteilt, dass er diese Funktion dieser Instanz aufrufen kann.
        this.svcSA.registerAppointmentsFunc(this.loadOrders.bind(this));
    }

    async loadOrders() {
        await this.loadObjektKategorienFromIndexedDB();
        let value = await this.loadAuftraegeFromIndexedDB();
        if (value) {
            this.svcSA.getChoosedAppointmentFromDB().then((value) => {
                this.lastChoosedRowID = value;
                this.currTermin = this.dbTermine?.find((x) => x.rowID == this.lastChoosedRowID);
                if (this.currTermin) {
                    this.svcSA.setTermin(this.currTermin);
                    this.saComp.reloadAppointment(this.currTermin);
                }
            });
        }

        this.scheduleObj!.eventSettings.dataSource = [];
        //  this.scheduleObj!.refreshEvents();  01.04.2022/TH: Diese Zeile gibt manchmal Fehler aus
        this.scheduleObj!.refresh();
        this.scheduleObj!.eventSettings.dataSource = this.myDataSource;
    }

    noTerminSelected() {
        this.lastClickedAppointment = null;
        this.lastClickedAppointmentEvent = null;
        this.currClickedAppointment = null;
        this.currClickedAppointmentEvent = null;
        this.lastChoosedRowID = '';
        this.scheduleObj!.refresh();
    }

    onDragStartEvent(args: any) {
        this.terminBefore = {
            Id: args.data.Id,
            StartTime: args.data.StartTime,
            EndTime: args.data.EndTime,
        };
    }

    onDragStopEvent(args: any) {
        this.terminAfter = {
            Id: args.data.Id,
            StartTime: args.data.StartTime,
            EndTime: args.data.EndTime,
        };
        // Termin muss sofort aktualisiert werden in der Einsatzplanung (Navi)
        this.UpdateTermin();
    }

    formatDate(datum: Date): string {
        // Formatiert das Datum in das Format "dd.MM.yyy HH.mm.ss"
        return this._datumFormatPipe.transformOnlyDate(datum);
    }

    async loadObjektKategorienFromIndexedDB(): Promise<boolean> {
        return this.localStorageService
            .get('objektKategorien', this.dbStorageSA)
            .then((value) => {
                if (value === false) {
                    // Es konnte keinen Wert in der indexeddb für Objekte/Aufträge ermittelt werden
                    return false;
                } else {
                    // Die Aufträge konnten geladen werden
                    if (value) {
                        //this.dbAuftraege = <ServiceAppModels.Objekte>value;
                        this.dbAuftragsKategorien = <ServiceAppModels.SA_ObjektKategorie[]> (
                            value
                        );
                    }
                    return true;
                }
            });
    }

    async loadAuftraegeFromIndexedDB(): Promise<boolean> {
        let value = await this.localStorageService.get('objekte', this.dbStorageSA, false, []);
        this.dbTermine = <ServiceAppModels.SA_Objekt[]> value;
        let dataSource: object[] = [];

        for (let auftrag of this.dbTermine) {
            // Kunde ermitteln => Ist das nötig?
            //let adr = this.dbAuftraege!.sA_ObjectAdress.filter(oa => oa.fK_ObjectID === auftrag.objectID);
            let noteInfo = '';
            try {
                if (auftrag.notes && auftrag.notes.length > 0) {
                    noteInfo = ' (*)';
                }
            } catch (ex) {
                console.error('Fehler: ', ex);
            }

            if (auftrag.fK_EmpWorkPlanCategoryID) {
                dataSource.push({
                    Id: auftrag.rowID,
                    Subject: `${auftrag.objectNumber.trim() + ' '}${auftrag.objDescription}\n${auftrag.note4}`,
                    ProjectLeader: auftrag.projectLeader,
                    ObjectNumber: auftrag.objectNumber.trim(),
                    ObjectDescription: auftrag.objDescription,
                    Note4: auftrag.note4,
                    StartTime: auftrag.startTime,
                    EndTime: auftrag.endTime,
                    IsAllDay: false,
                    Type: this.dbAuftragsKategorien!.filter((ak) => ak.id === auftrag.fK_EmpWorkPlanCategoryID)[0].description,
                    AdditionalWork: auftrag.additionalWork,
                    Notes: auftrag.notes,
                    ServiceComplete: auftrag.serviceComplete,
                });
            } else {
                dataSource.push({
                    Id: auftrag.rowID,
                    Subject: `${auftrag.objectNumber.trim() + ' '}${auftrag.objDescription}\n${auftrag.note4}${auftrag.projectLeader}`,
                    ProjectLeader: auftrag.projectLeader,
                    ObjectNumber: auftrag.objectNumber.trim(),
                    ObjectDescription: auftrag.objDescription,
                    Note4: auftrag.note4,
                    StartTime: auftrag.startTime,
                    EndTime: auftrag.endTime,
                    IsAllDay: false,
                    AdditionalWork: auftrag.additionalWork,
                    Notes: auftrag.notes,
                    ServiceComplete: auftrag.serviceComplete,
                });
            }

        }

        if (this.scheduleObj) {
            try {
                this.myDataSource = dataSource;
                this.scheduleObj.eventSettings.dataSource = dataSource;
                this.flag = true;
                this.changeDetection.markForCheck();
            } catch (ex) {
                console.error('Fehler beim Laden der Termine.', ex);
            }
        }
        return true;
    }

    public onEventRendered(args: any): void {
        // Standard-Farben der Aufträge setzen
        let bg;
        if (args.data.Type && this.dbAuftragsKategorien) {
            if (args.data.ServiceComplete === 0) {
                bg = this.getBackgroudColorByType(args.data.Type);
            } else {
                bg = this.getBackgroundColorByServiceComplete(args.data.ServiceComplete);
            }
        } else {
            bg = this.getBackgroundColorByServiceComplete(args.data.ServiceComplete);
        }
        args.element.style.backgroundColor = bg;
        args.element.style.color = this.getColorByBackground(bg);
        if (args.data.Notes) {
            args.element.classList.add('has-note');
        }
    }

    getColorByBackground(hexcolorstring) {
        if (hexcolorstring) {
            const c = hexcolorstring.substring(1);      // strip #
            const rgb = parseInt(c, 16);   // convert rrggbb to decimal
            const r = (rgb >> 16) & 0xff;  // extract red
            const g = (rgb >> 8) & 0xff;  // extract green
            const b = (rgb >> 0) & 0xff;  // extract blue
            const luma = r * 0.299 + g * 0.587 + b * 0.114;
            return (luma >= 128) ? 'black' : 'white';
        }
        return 'white';
    }


    onNavigate(args: any) {
        if (args.action === 'view') {
            this.svcSA.setLastChosenView(args.currentView);
        }
    }

    onPopupClose(args: PopupCloseEventArgs) {
        if (args.type === 'Editor') {
            if (
                ['Add', 'Save', 'EditSeries', 'EditOccurrence'].indexOf(
                    this.scheduleObj!.currentAction
                ) > -1
            ) {
                // Handle the code if "save" button is clicked.
                console.log('onPopupClose', args);

                if (this.currTermin && args.data) {
                    this.terminBefore = {
                        Id: this.currTermin.rowID,
                        StartTime: this.currTermin.startTime,
                        EndTime: this.currTermin.endTime,
                    };

                    this.terminAfter = {
                        Id: this.currTermin?.rowID,
                        StartTime: args.data.StartTime,
                        EndTime: args.data.EndTime,
                    };
                    this.UpdateTermin();
                }
            }
        }
    }

    onPopupOpen(args: PopupOpenEventArgs) {
        args.cancel = true;

        if (args.data?.Id) {
            // Die nächste Zeile ist drin, weil sonst das Drag&Drop auf Android nicht funktioniert
            if (this.isAndroid) {
                return;
            }
            this.onEditEinsatz();
        } else {
            this.onNewEinsatz();
        }
    }

    onNewEinsatz() {
        const user = this.userAuthService.getCurrentAuthenticatedUser()!;

        this.dataForAssignment = {
            employeeID: user.employeeID,
            mandator: user.mandatorID,
            rowID: uuidv4(),
            serviceID: uuidv4(),
            objectID: '',
            day: undefined,
            startTime: undefined,
            endTime: undefined,
        };
        if (this.scheduleObj) {
            if (this.scheduleObj.activeCellsData.element) {
                let selectedDate = this.scheduleObj.activeCellsData.startTime;
                this.dataForAssignment.day = new Date(
                    this._datumFormatPipe.transform(selectedDate, 'yyyy-MM-ddT') + '00:00:00'
                );
                this.dataForAssignment.startTime = selectedDate;
                this.dataForAssignment.endTime =
                    this.scheduleObj.activeCellsData.endTime;
            }
        }

        const dialogRef = this.dialog.open(EinsatzEintragComponent, {
            disableClose: true,
            data: this.dataForAssignment,
        });

        dialogRef.afterClosed().subscribe({
            next: async (result) => {
                if (result) {
                    // Neuer Einsatz wurde erfolgreich gespeichert, nun muss dieser der Agenda hinzugefügt werden.
                    // Sobald dieser geladen ist, ruft der SA-Service die Methode loadOrders auf
                    await this.svcSA.addAuftragByRowID((result as ServiceAppModels.Assignment).rowID);
                }
            },
        });
    }

    onEditEinsatz() {
        this.svcSA.showAppointmentDetails();
    }

    onEventClick(args: any): void {
        if (args.event.Id) {
            // Aktuelles Termin-Objekt ermitteln
            this.currTermin = this.dbTermine?.filter(
                (x) => x.rowID == args.event.Id
            )[0];
            if (this.swissSettings.getWebConfig().debugMode) {
                console.log('currTermin', this.currTermin);
            }

            // Termin für das "Wieder-Laden" beim App-Start in IndexedDB speichern
            this.svcSA.saveChoosedAppointmentToDB(this.currTermin!.rowID);

            // Termin gründ einfärben
            if (this.currClickedAppointment) {
                this.lastClickedAppointment = this.currClickedAppointment;
                this.lastClickedAppointmentEvent = this.currClickedAppointmentEvent;
            }

            this.currClickedAppointment = args.element;
            this.currClickedAppointmentEvent = args.event;
            if (this.currClickedAppointment) {
                if (this.swissSettings.getWebConfig().debugMode) {
                    console.log('Selected Element:', this.currClickedAppointment);
                }
                args.element.style.backgroundColor = 'Green';
                if (
                    this.lastClickedAppointment &&
                    this.lastClickedAppointment != this.currClickedAppointment
                ) {
                    // Zuletzt angeklickten Termin nicht mehr Grün einfärben
                    if (this.lastClickedAppointmentEvent && this.lastClickedAppointmentEvent.Type) {
                        if (this.lastClickedAppointmentEvent.ServiceComplete === 0) {
                            this.lastClickedAppointment.style.backgroundColor = this.getBackgroudColorByType(this.lastClickedAppointmentEvent.Type);
                        } else {
                            this.lastClickedAppointment.style.backgroundColor = this.getBackgroundColorByServiceComplete(this.lastClickedAppointmentEvent.ServiceComplete);
                        }
                    } else {
                        this.lastClickedAppointment.style.backgroundColor = this.getBackgroundColorByServiceComplete(this.lastClickedAppointmentEvent.ServiceComplete);
                    }
                }
            }

            if (this.currTermin) {
                try {
                    this.svcSA.setTermin(this.currTermin);
                    this.saComp.reloadAppointment(this.currTermin);
                } catch (ex) {
                    console.error(
                        'agenda.component.ts;onEventClick();Fehler im Event-Aufruf',
                        ex
                    );
                }
            }
        }
    }

    startTimeRecording() {
        var dialogRef = this.dialog.open(TimeRecorderComponent, {
            disableClose: true,
        });

        return dialogRef.afterClosed().subscribe({
            next: (result) => {
                if (result) {
                    this.timeRecordingItem = result;
                    if (this.timeRecordingItem) {
                        this.showRecordState = this.timeRecordingItem.recordingState;
                        this.showObjektRecordingData();
                    }
                }
            },
        });
    }

    reStartTimeRecording() {
        var dialogRef = this.dialog.open(TimeRecorderComponent, {
            disableClose: true,
            data: this.timeRecordingItem,
        });

        return dialogRef.afterClosed().subscribe({
            next: (result) => {
                if (result) {
                    this.timeRecordingItem = result;
                    if (this.timeRecordingItem) {
                        this.showRecordState = this.timeRecordingItem.recordingState;
                        this.showObjektRecordingData();
                    }
                }
            },
        });
    }

    stopTimeRecording() {
        if (
            this.timeRecordingItem!.recordingState ===
            ServiceAppModels.RecordingState.InBreak
        ) {
            // Nach einer Pause wurde gestoppt => Zeit wurde bereits gespeichert.
            this.timeRecordingItem!.recordingState =
                ServiceAppModels.RecordingState.NoRecording;
            this.showRecordState = this.timeRecordingItem!.recordingState;
            this.svcSA.stopTimeRecording(this.timeRecordingItem!, true);
        } else {
            // Eine laufende Aufnahme wurde gestoppt.
            this.timeRecordingItem!.recordingState =
                ServiceAppModels.RecordingState.NoRecording;
            this.showRecordState = this.timeRecordingItem!.recordingState;
            this.timeRecordingItem!.endTime = new Date();
            this.svcSA.stopTimeRecording(this.timeRecordingItem!, false);
        }
        this.timeRecordingItem = undefined;
        this.startZeitRecording = undefined;
        this.tagesTotal = undefined;
        this.auftragsZeitTotal = undefined;
        this.currTimeRecordObjekt = undefined;
        this.currTimeRecordTermin = undefined;
    }

    breakTimeRecording() {
        this.timeRecordingItem!.recordingState =
            ServiceAppModels.RecordingState.InBreak;
        this.showRecordState = this.timeRecordingItem!.recordingState;
        this.timeRecordingItem!.endTime = new Date();
        this.svcSA.addTimeRecording(this.timeRecordingItem!);
    }

    private UpdateTermin() {

        if (this.svcSA.getSA_Config()?.verschiebungVonTerminenErlauben) {
            this.svcSA.updateAppointment(this.terminAfter!).then((res) => {
                if (res) {
                    //console.log("Termin wurde in der Einsatzplanung aktualisiert.");
                    this.svcSA.updateAppointmentInLocalDB(this.terminAfter!);
                } else {
                    //console.log("Termin wurde NICHT in der Einsatzplanung aktualisiert.");
                    this.svcMessageBox.showError(
                        '⚠️ ❗❗ Der Termin konnte nicht verschoben werden!! ❗❗ ⚠️ <br/>' +
                        '👉 Man muss online sein und der Webservice muss ereichbar sein.',
                        '!! FEHLER !!'
                    );
                    this.loadOrders();
                }
            });
        } else {
            this.svcMessageBox.showError(
                '⚠️ ❗❗ Der Termin konnte wegen fehlender Berechtigungen nicht verschoben werden!! ❗❗ ⚠️ ',
                '!! FEHLER !!'
            );
            this.loadOrders();
        }
    }

    private getBackgroundColorByServiceComplete(serviceComplete: number) {
        if (serviceComplete === 0) {
            return '#CC3335'; // rot
        } else {
            return '#6A25B4'; // violett
        }
    }

    private getBackgroudColorByType(type?: string): string {
        let col: string = '';
        if (this.dbAuftragsKategorien) {
            if (type) {
                col = this.dbAuftragsKategorien.filter(
                    (ak) => ak.description === type
                )[0].hexColor;
            } else {
                col = this.dbAuftragsKategorien[0].hexColor;
            }
        }
        return col;
    }

    /* Footer - Funktionen */
    private async refreshObjektRecordingData() {
        /* Loop-Funktion */
        this.refreshObjectRecordingInterval = setInterval(() => {
            if (this.timeRecordingItem) {
                this.showObjektRecordingData();
            }
        }, 5000);
    }

    private showObjektRecordingData() {
        if (this.timeRecordingItem) {
            this.startZeitRecording = this.timeRecordingItem.onlyTime;
            let currDuration: number = 0;
            if (
                this.timeRecordingItem.recordingState ===
                ServiceAppModels.RecordingState.InRecording
            ) {
                // In Aufnahme
                currDuration = this._datumFormatPipe.ouersBetweenToDates(
                    this.timeRecordingItem.startTime!,
                    new Date()
                );
            }
            this.tagesTotal = (currDuration + this.svcSA.getTagesTotal()).toString();

            // Wurde die Zeitaufzeichnung auf einen geplanten Auftrag gemacht?
            if (this.timeRecordingItem?.serviceID) {
                this.currTimeRecordTermin = this.svcSA.getTerminByServiceID(
                    this.timeRecordingItem?.serviceID
                );
                this.currTimeRecordObjekt = undefined;
                this.auftragsZeitTotal = (
                    currDuration +
                    this.svcSA.getAuftragsTotalGeplant(this.timeRecordingItem?.serviceID)
                ).toString();
            } else {
                this.svcObjekte
                    .getObjektByID(this.timeRecordingItem!.objectID)
                    .subscribe({
                        next: (res: ObjektModels.ObjektElement | undefined) => {
                            if (res) {
                                this.currTimeRecordObjekt = res;
                                this.currTimeRecordTermin = undefined;
                                this.auftragsZeitTotal = (
                                    currDuration +
                                    this.svcSA.getAuftragsTotalUngeplant(
                                        this.timeRecordingItem!.objectID
                                    )
                                ).toString();
                            }
                        },
                    });
            }
        } else {
            this.currTimeRecordObjekt = undefined;
            this.currTimeRecordTermin = undefined;
        }
    }
}
